import { type ReactNode, useId } from 'react';

export interface SettingRowIds {
  /** For the control's `aria-labelledby`. */
  labelId: string;
  /** For the control's `aria-describedby`. */
  hintId: string;
}

interface SettingRowProps {
  label: string;
  hint: string;
  /** The control, wired to the label and hint by id so it is announced as this setting. */
  children: (ids: SettingRowIds) => ReactNode;
}

/** One row of a flat settings list: label and help on the left, control on the right. */
export function SettingRow({ label, hint, children }: SettingRowProps) {
  const id = useId();
  const ids = { labelId: `${id}-label`, hintId: `${id}-hint` };
  return (
    <div className="grid gap-3 py-5 md:grid-cols-[minmax(0,1fr)_auto] md:items-center">
      <div className="flex flex-col gap-0.5">
        <span className="font-medium" id={ids.labelId}>
          {label}
        </span>
        <span
          className="text-muted-foreground max-w-[48ch] text-[13px] leading-[18px]"
          id={ids.hintId}
        >
          {hint}
        </span>
      </div>
      <div className="flex md:justify-end">{children(ids)}</div>
    </div>
  );
}
